import {Component} from '@angular/core';
import {NavParams} from 'ionic-angular';

import {EnumNames} from '../../model/enums';
import {Person} from '../../model/person';

import {isAnyPropertySet} from '../../util/util';

import { SterbefallProvider } from '../../providers/sterbefall.provider';


/**
 * Seite zum Bearbeiten oder Anlegen eines Verwandten.
 * Zum Bearbeiten muss der Index des Verwandten im Parameter "verwandter-index"
 * gegeben sein. Fehlt er, wird ein neuer Verwandter angelegt und beim Verlassen
 * der Seite gespeichert (sofern Daten hinterlegt sind).
 *
 * @author Andreas Wenger
 */
@Component({
	templateUrl: 'verwandter.html'
})
export class VerwandterPage {

	verwandter: Person;
	isNew: boolean;

	constructor(navParams: NavParams, public sterbefallProvider : SterbefallProvider) {
		let index = navParams.get('verwandter-index');
		this.isNew = (index == undefined);
		if (this.isNew)
			this.verwandter = new Person();
		else
			this.verwandter = sterbefallProvider.aktuellerSterbefall.verwandte[index];
	}

	ionViewWillLeave() {
		if (this.isNew && isAnyPropertySet(this.verwandter))
			this.sterbefallProvider.aktuellerSterbefall.verwandte.push(this.verwandter);
	}

	//helper
	get artNames() { return EnumNames.verwandtschaftsArtNames; }
	get anredeNamesOhneFirma() { return EnumNames.anredeNamesOhneFirma; }

}



// WEBPACK FOOTER //
// ./src/pages/verwandter/verwandter.ts